// eslint-disable-next-line
import React from 'react'

import AssignmentIcon from '@material-ui/icons/Assignment'

import axios from 'axios'

import styles from './JournalRegisters.module.css'

import PropTypes from 'prop-types'

import SimpleTable from '../../SimpleTable/SimpleTable'
import ProgressBar from "../../ProgressBar/ProgressBar";
import JournalSearchForm from './JournalSearchForm'
import { withRouter } from 'react-router-dom'
import { Table,TableRow,TableCell } from '@material-ui/core'
import AlertMessage from '../../Notify/AlertMessage'

import PrintIcon from '@material-ui/icons/Print'
import ReactToPrint from "react-to-print";
import { IconButton } from '@material-ui/core';
export const Component = withRouter(() => {

})

class JournalRegisters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      model: 'Journal Register',
      journalRegisters: [],
      searchParams: {is_posted: 'true'},
      title: '',
      load: false,
      tableHead: ['date_of_journal', 'reference_no', 'branch_name', 'is_posted', 'journal_entries'],
      branch: {},
      branches: [],
      currentPage: 1,
      totalPages: 1,
      forPrint: false,
      urlPrint: {},
      totalLength: 0,
      isOpen: false,
      message: '',
      type: '',
      searchUrl: process.env.REACT_APP_API_DOMAIN + '/v1/journals/search'
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleAutoComplete = this.handleAutoComplete.bind(this)
    this.clearSearch = this.clearSearch.bind(this)
    this.handleCloseAlert = this.handleCloseAlert.bind(this)
    this.changePrintLayout = this.changePrintLayout.bind(this)
  }

  componentDidMount() {
    var searchUrl = this.state.searchUrl + this.props.location.search
    var searchParams = {is_posted: 'true'}
    const params = new URLSearchParams(this.props.location.search)
    // This is to load all params based on URLSearchParams
    params.forEach(function(value, key) {
      if (key !== 'page' ) {
        searchParams[key] = value
      }
    })

    if (searchParams.branch_id !== null && searchParams.branch_id !== undefined && searchParams.branch_id !== '') {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_DOMAIN + '/v1/branches/' + searchParams.branch_id,
        headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
      }).then(resp => {
        this.setState({ searchParams: { ...this.state.searchParams, branch_id: resp.data } })
      })
    }
    
    this.setState({ searchParams: searchParams })
    this.loadGeneralJournalRegisters(searchUrl, this.props.location.search ? true : false)
  }

  loadGeneralJournalRegisters(url,withSearchParams ) {
    if (withSearchParams) {
      axios({
        method: 'get',
        url: url.includes('?') ? url+'&resource_type=Journal&per_page=100000&sort_by[date_of_journal]=desc': url+'?resource_type=Journal&per_page=100000&sort_by[date_of_journal]=desc',
        headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
      }).then(resp => {
        if(resp.data.journals.length>0){
          this.setState({totalLength: resp.data.journals.length})
          var journalArray = []
          var isDoneLoading = false
          resp.data.journals.map((journal, idx) => {
            var item = journal
    
            axios({
              method: 'get',
              url: process.env.REACT_APP_API_DOMAIN + '/v1/journals/' + journal.id + '/journal_entries',
              headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
            }).then(resp => {
              item["journal_entries"] = resp.data
              journalArray.push(item)
              this.setState({ journalRegisters: [...this.state.journalRegisters, item] })
            })
            if (resp.data.journals.length - 1 === idx) {
              isDoneLoading = true
    
            }
          })
          this.setState({ load: isDoneLoading })
          this.setState({ urlPrint: resp.data.meta })
        }else{
          this.setState({ load: true })
        }
        
      
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_DOMAIN + '/v1/branches',
          headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
        }).then(resp => {
          this.setState({ branches: resp.data })
          this.setState({ load: true })
        })
      }).catch((error) => {
        if(error.response)
        {this.setState({load: true, isOpen: true, message: error.response.status + " Unexpected Problem Occurred",type: 'error'})}
      })
    }else {
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_DOMAIN + '/v1/branches',
        headers: { 'X-API-ACCESS-TOKEN': localStorage.getItem('api_key') }
    }).then(resp => {
        this.setState({ branches: resp.data,load: true })
    })
    }
  }

  handleSubmit() {
    this.setState({journalRegisters: [], load:false})
    const { history } = this.props
    var searchParams = this.getSearchParams().join("&")
    const params = new URLSearchParams()
    params.append("/search", searchParams)
    history.push({ search: searchParams })
    this.loadGeneralJournalRegisters([this.state.searchUrl, searchParams].join("?"), true, false)
  }

  handlePageChange(event, value) {
    var searchParams = this.getSearchParams()
    searchParams.push(["page", value].join("="))
    searchParams = searchParams.join("&")

    const { history } = this.props
    const params = new URLSearchParams()

    params.append("/search", searchParams)
    history.push({ search: searchParams })
    this.setState({ currentPage: value })
    this.lo([this.state.searchUrl, searchParams].join("?"))
  }

  getSearchParams() {
    var searchParams = []
    // This is to load all params based on searchParams state.
    Object.entries(this.state.searchParams).map(([key, value]) => {
      if (value != '' && value != undefined && value != null) {
        if(key === "branch_id") {
          searchParams.push([key, value.id].join("="))
        }else {
          searchParams.push([key, value].join("="))
        }
      }
    })

    return searchParams
  }

  handleInputChange(e) {
    if (e.target.name === "starts_on_from") {
      var dateStart = new Date(e.target.value).toLocaleDateString('fr-Ca')
      var lastDay = new Date(new Date(dateStart).getFullYear(), new Date(dateStart).getMonth() + 1, 0).toLocaleDateString('fr-Ca')
      this.setState({
        searchParams: {
          ...this.state.searchParams,
          [e.target.name]: e.target.value,
          starts_on_to: lastDay
        }
      })
    }
    else {
      this.setState({
        searchParams: {
          ...this.state.searchParams,
          [e.target.name]: e.target.value
        }
      })
    }
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleSubmit()
    }
  }

  clearSearch() {
    const { history } = this.props
    history.push({ search: '' })
    this.setState({ searchParams: { starts_on_from: '', starts_on_to: '', is_posted: '', branch_id: {} } })
    this.setState({ journalRegisters: [],urlPrint: {} })
  }

  handleAutoComplete(event, values) {
    this.setState({
      searchParams: {
        ...this.state.searchParams,
        branch_id: values
      }
    })
  }

  grandDebit() {
    var totalDebit = 0
    if (this.state.journalRegisters.length > 0) {
      this.state.journalRegisters.map((content) => {
        content.journal_entries.map((debit) => {
          totalDebit = parseFloat(totalDebit) + parseFloat(debit.amount_debit)
        })
      })
    }
    return totalDebit
  }

  grandCredit() {
    var totalCredit = 0
    if (this.state.journalRegisters.length > 0) {
      this.state.journalRegisters.map((content) => {
        content.journal_entries.map((credit) => {
          totalCredit = parseFloat(totalCredit) + parseFloat(credit.amount_credit)
        })
      })
    }
    return totalCredit
  }

  handleCloseAlert (event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({isOpen: false})
  }

  changePrintLayout() {
    return new Promise((resolve) => {
        this.setState({ forPrint: !this.state.forPrint }, () => resolve());
      });     
  }

  render() {
    const printPdf = <ReactToPrint
      trigger={() => {
          return <IconButton color="primary"><PrintIcon /></IconButton>
      }}
      onBeforeGetContent={this.changePrintLayout}
      onAfterPrint={this.changePrintLayout}
      content={() => this.componentRef}
      />
    return (
      <>
        {
          this.state.load ? (
            <div>
              <JournalSearchForm
                item={this.state.searchParams}
                branches={this.state.branches}
                handleChange={this.handleInputChange}
                search={this.handleSubmit}
                clearSearch={this.clearSearch}
                handleAutoComplete={this.handleAutoComplete}
                handleKeyPress={this.handleKeyPress}
              />
              <div ref={el => (this.componentRef = el)} >
              <SimpleTable
                handleClick={this.handleCreateorUpdateItem}
                handlePageChange={this.handlePageChange}
                items={this.state.journalRegisters}
                model={this.state.model}
                totalPages={this.state.totalPages}
                withPagination={this.state.withPagination}
                currentPage={this.state.currentPage}
                headers={this.state.tableHead}
                icon={this.state.forPrint? null:<AssignmentIcon fontSize="large" />}
                urlPrint={this.state.urlPrint}
                withPrint={true}
                headerTitle="Journal Registers"
                forPrint={this.state.forPrint}
                printPdf={printPdf}
              />
             {this.state.journalRegisters.length > 0 ? (
                <Table>
                  <TableRow className="fixWidth">
                    <TableCell className={styles.cellNone}></TableCell>
                    <TableCell className={styles.grandTotal}>Grand Total</TableCell>
                    <TableCell
                      className={styles.grandDebit}>{this.grandDebit().toLocaleString(navigator.language, {minimumFractionDigits: 2})}</TableCell>
                    <TableCell
                      className={styles.grandCredit}>{this.grandCredit().toLocaleString(navigator.language, {minimumFractionDigits: 2})}</TableCell>
                  </TableRow>
                </Table>
              ) : null}
              </div>
              <AlertMessage
                handleCloseAlert={this.handleCloseAlert}
                isOpen={this.state.isOpen}
                type={this.state.type}
                message={this.state.message}
              />
            </div>
          ) : (
            <ProgressBar model={this.state.model} />
          )}
      </>
    )
  }
}

export default withRouter(JournalRegisters)

JournalRegisters.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}
